<template>
    <div id="computer">

        <div class="grid grid-cols-3 gap-1 signboard">
            <div>
                <div class="inCenterY">
                    <svg class="w-[45px] h-[45px] accountEntrance" @click="openAccountList" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                        <path fill="#FFFFFF" d="M399 384.2C376.9 345.8 335.4 320 288 320l-64 0c-47.4 0-88.9 25.8-111 64.2c35.2 39.2 86.2 63.8 143 63.8s107.8-24.7 143-63.8zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256 16a72 72 0 1 0 0-144 72 72 0 1 0 0 144z"/>
                    </svg>
                    <!-- <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M257 8C120 8 9 119 9 256s111 248 248 248 248-111 248-248S394 8 257 8zm-49.5 374.8L81.8 257.1l125.7-125.7 35.2 35.4-24.2 24.2-11.1-11.1-77.2 77.2 77.2 77.2 26.6-26.6-53.1-52.9 24.4-24.4 77.2 77.2-75 75.2zm99-2.2l-35.2-35.2 24.1-24.4 11.1 11.1 77.2-77.2-77.2-77.2-26.5 26.5 53.1 52.9-24.4 24.4-77.2-77.2 75-75L432.2 255 306.5 380.6z"/></svg> -->
                </div>
            </div>
            <div>
                <div class="inCenter">
                    <div class="circle">
                        <img class="ml-[6px] mt-[4px] mr-[2px] mb-[4px]" src="@/assets/img/favicon-32x32.png" />
                    </div>
                </div>
            </div>
            <div>
                <div class="inCenterY" style="float:right;">
                    <svg class="w-[45px] h-[45px] gameEntrance" @click="openGameList" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                        <path fill="#FFFFFF" d="M352 256c0 22.2-1.2 43.6-3.3 64l-185.3 0c-2.2-20.4-3.3-41.8-3.3-64s1.2-43.6 3.3-64l185.3 0c2.2 20.4 3.3 41.8 3.3 64zm28.8-64l123.1 0c5.3 20.5 8.1 41.9 8.1 64s-2.8 43.5-8.1 64l-123.1 0c2.1-20.6 3.2-42 3.2-64s-1.1-43.4-3.2-64zm112.6-32l-116.7 0c-10-63.9-29.8-117.4-55.3-151.6c78.3 20.7 142 77.5 171.9 151.6zm-149.1 0l-176.6 0c6.1-36.4 15.5-68.6 27-94.7c10.5-23.6 22.2-40.7 33.5-51.5C239.4 3.2 248.7 0 256 0s16.6 3.2 27.8 13.8c11.3 10.8 23 27.9 33.5 51.5c11.6 26 20.9 58.2 27 94.7zm-209 0L18.6 160C48.6 85.9 112.2 29.1 190.6 8.4C165.1 42.6 145.3 96.1 135.3 160zM8.1 192l123.1 0c-2.1 20.6-3.2 42-3.2 64s1.1 43.4 3.2 64L8.1 320C2.8 299.5 0 278.1 0 256s2.8-43.5 8.1-64zM194.7 446.6c-11.6-26-20.9-58.2-27-94.6l176.6 0c-6.1 36.4-15.5 68.6-27 94.6c-10.5 23.6-22.2 40.7-33.5 51.5C272.6 508.8 263.3 512 256 512s-16.6-3.2-27.8-13.8c-11.3-10.8-23-27.9-33.5-51.5zM135.3 352c10 63.9 29.8 117.4 55.3 151.6C112.2 482.9 48.6 426.1 18.6 352l116.7 0zm358.1 0c-30 74.1-93.6 130.9-171.9 151.6c25.5-34.2 45.2-87.7 55.3-151.6l116.7 0z"/>
                    </svg>
                    <!-- <img  class="gameEntrance" @click="openGameList" src="@/assets/img/game.32.32.png" /> -->
                </div>
            </div>
        </div>

        <!-- 这个功能藏起来，自己测试用的 -->
        <router-link to="/computer/live" class="action-item">
            <svg class="action-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
                <path fill="currentColor" d="M336.2 64H47.8C21.4 64 0 85.4 0 111.8v288.4C0 426.6 21.4 448 47.8 448h288.4c26.4 0 47.8-21.4 47.8-47.8V111.8c0-26.4-21.4-47.8-47.8-47.8zm189.4 37.7L416 177.3v157.4l109.6 75.5c15.2 10.5 26.4 1.3 26.4-11.9V113.6c0-13.2-11.2-22.4-26.4-11.9z"/>
            </svg>
            <div>{{ $t('page.live') }}</div>
        </router-link>


        <!-- van-pull-refresh：下拉刷新 -->
        <van-pull-refresh  class="demo-refresher" v-model="isLoading" :head-height="50" @refresh="onRefresh" loosing-text="释放即可刷新" pulling-text="下拉刷新" success-text="刷新成功">

            <!-- 上拉加载 -->
            <!-- :finished="finished" // 是否已加载完成，加载完成后不再触发load事件 -->
            <!-- :offset="10" // 滚动条与底部距离小于offset时触发load事件 -->
            <!-- :immediate-check="flase" // 是否在初始化时立即执行滚动位置检查 -->
            <!-- @load="onLoad 滚动条与底部距离小于offset时触发onLoad() -->
            <van-list class="vanList" v-model:loading="loading" :finished="finished" :immediate-check="false" finished-text="没有更多了" @load="onLoad" :offset="3">
                <div class="video-grid">
                    <div
                        class="video-card"
                        v-for="(item, index) in list"
                        :key="item.video_id || index"
                        @click="goPlay(item)"
                    >
                        <div class="video-cover">
                            <img
                                :src="domain + '/xox/' + item.free + '/' + item.thumb"
                                :alt="item.title"
                            />
                        </div>
                        <div class="video-title-slot">
                            <div
                                class="video-title-track"
                                :class="{ 'is-scrolling': isLongTitle(item.title) }"
                            >
                                <span class="video-title-text">{{ item.title }}</span>
                                <span
                                    v-if="isLongTitle(item.title)"
                                    class="video-title-text"
                                    aria-hidden="true"
                                >{{ item.title }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </van-list>
        </van-pull-refresh>
   

    
       


       
        <!-- <Carousel />
        <Carousel />
        <Carousel />
        <Carousel />
        <Carousel />
        <Carousel /> -->



        <!-- swiper 广告的东西放最后 -->
        <!-- <div class="swiper">
            <swiper
                :slidesPerView="1"
                :spaceBetween="30"
                :loop="true"
                :centeredSlides="true"
                :pagination="{ clickable: true }"
                :autoplay="{ delay: 3000, disableOnInteraction: false}"
                :navigation="false"
                :modules="modules"
            >
                <swiper-slide><img src="/upload/4ab790e14459500d.png" alt="" /></swiper-slide>
                <swiper-slide><img src="/upload/779a5fc5897127a6.png" alt="" /></swiper-slide>
                <swiper-slide><img src="/upload/a9a212de5251be43.png" alt="" /></swiper-slide>
            </swiper>
            <div class="pagination"></div>
            <div class="swiper-scrollbar"></div>
        </div> -->
        <!-- /end swiper -->

        

        <mainMenu />

        <!-- 右下角悬浮分页 -->
        <div class="float-pager" v-show="totalPages > 0">
            <button
                type="button"
                class="float-pager-btn"
                :class="{ disabled: !isJumpMode && incomePayData.pageNumber <= 1 }"
                :disabled="!isJumpMode && incomePayData.pageNumber <= 1"
                @click="onPagerTopClick"
            >{{ isJumpMode ? '确定跳转' : '上一页' }}</button>
            <input
                class="float-pager-input"
                type="number"
                inputmode="numeric"
                min="1"
                :max="totalPages"
                :placeholder="String(incomePayData.pageNumber)"
                v-model="jumpPageInput"
                @keyup.enter="confirmJumpPage"
            />
            <button
                type="button"
                class="float-pager-btn"
                :class="{ disabled: !isJumpMode && incomePayData.pageNumber >= totalPages }"
                :disabled="!isJumpMode && incomePayData.pageNumber >= totalPages"
                @click="onPagerBottomClick"
            >{{ isJumpMode ? '确定跳转' : '下一页' }}</button>
        </div>

        <!-- 自定义颜色的遮罩层 :shade="[0.5, '#fadfd9']" -->
        <!-- 点击遮罩层则关闭弹出层 :shadeClose="true" -->
        <!-- 不显示关闭按钮 :closeBtn="0" -->
        <s3-layer class="notConfirmed" v-model="layerAccount" :shade="[0.5, '#fadfd9']" :shadeClose="true" :closeBtn="0" :anim="2" offset='50px' :title="title" area="100%">
            <!-- 弹出用户帐号快捷菜单 -->
            新功能开发中...
            <!-- /End 弹出用户帐号快捷菜单 -->
        </s3-layer>

        <s3-layer
            class="notConfirmed"
            v-model="layerGame"
            :shade="[0.5, '#fadfd9']"
            :shadeClose="true"
            :closeBtn="0"
            :anim="3"
            offset="50px"
            :title="categoryLayerTitle"
            area="100%"
        >
            <div class="category-panel">
                <button
                    type="button"
                    class="category-tag"
                    :class="{ active: categoryId === 0 }"
                    @click="selectCategory(0)"
                >所有</button>
                <button
                    v-for="c in categories"
                    :key="c.category_id"
                    type="button"
                    class="category-tag"
                    :class="{ active: categoryId === c.category_id }"
                    @click="selectCategory(c.category_id)"
                >{{ c.title }}</button>
            </div>
        </s3-layer>

    </div>
</template>

<script>
import { layer } from "vue3-layer"
import { useI18n } from 'vue-i18n'
// import { ref } from 'vue'
// 轮播图
// Import Swiper Vue.js components
import { Swiper, SwiperSlide } from "swiper/vue"
// Import Swiper styles
// 引入swiper样式，对应css 如果使用less或者css只需要把scss改为对应的即可
import "swiper/css"
import "swiper/css/navigation"
import "swiper/css/pagination"
// setup 语法糖只需要这样创建一个变量就可以正常使用分页器和对应功能，如果没有这个数组则无法使用对应功能
import { Autoplay, Navigation, Pagination } from "swiper/modules"

// import marquee from "@/components/SimpleMarqueePc.vue"
import mainMenu from "@/components/computer/MainMenu.vue"
import postPages from "@/assets/js/postPages"
import Carousel from '@/components/CarouselList'
import format from '@/assets/js/formatDate'
// import { unmounted, onBeforeUnmount } from 'vue'
import global from '@/assets/js/global'
import axios from 'axios'

export default {
    components: {
        //   marquee,
        Swiper,
        SwiperSlide,
        // marquee,
        mainMenu,
        Carousel,
    },
    setup() {
        const upBalance = () => {
            if (global.debug) console.log(global.balance)
            axios.post(
                '/api/m/info/user', 
                {
                },
                {
                    headers: {
                        // 'Content-Type': 'multipart/form-data'
                        'Content-Type': 'application/x-www-form-urlencoded',
                        'Accept-Language': localStorage.getItem("lang"),
                        'token': localStorage.getItem('token')
                    }
                }
            )
            .then((response) =>  {
                if (0===response.data.code) {
                    global.balance = response.data.data.balance
                } else {
                    if (911===response.data.code) localStorage.removeItem('isLogin')
                }
            })
            .catch(function (error) {
                console.log(error)
            })
        }
        const token = localStorage.getItem('token') ? localStorage.getItem('token') : false
        const isLogin = localStorage.getItem('isLogin') ? localStorage.getItem('isLogin') : 0
        const formatFunc = format()
        
        // onBeforeUnmount(() => {
        //     // console.log( '组件卸载之前执行的函数' )
        //     window.removeEventListener('scroll', this.handleScroll, false)
        // })

        // 如果帐号已经退出  global.balance 会被设置为 -1 
        // 这时应该主动向后端更新当前用户的余额
        if (-1==global.balance && 1==global.isLogin) upBalance()


        return {
            upBalance,
            modules: [Autoplay, Navigation, Pagination],
            token,
            isLogin,
            ...formatFunc,
        }
    },
    data() {
        return {
            // 这里不要用配置文件中的域名，用当前用户访问时带进来的域名。
            // process.env.VUE_APP_VIDEO
            domain: typeof window !== 'undefined' ? window.location.origin : '',
            lang: '',
            languages: {
                'vi-vn': 'Tiếng Việt',
                'zh-cn': '中文',
            },
            showDropDown: false,
            slide: 0,
            api: {
                commodity: [],
            },
            layerAccount: false, // 控制左侧菜单的显示与隐藏
            layerGame: false, // 控制右侧菜单的显示与隐藏
            title: '帐号管理',
            categoryLayerTitle: '视频分类',
            categories: [],
            categoryId: 0, // 0 = 所有
            // 上拉下拉

            //传递给后端的参数
            incomePayData: {
                pageNumber: 1, //请求第几页
                pageSize: 12, //每页请求的数量（两列对齐）
            },
            list: [], //列表数据
            listTwo: [], //用于上拉加载时将数据合并
            total: 0, //总条数
            isLoading: false, // 下拉刷新状态 默认为不刷新
            loading: false, //上拉加载
            finished: false, //加载与不加载的状态
            loadingMore: false, // 防止上拉并发重复请求
            pageSwitching: false, // 悬浮分页翻页中，禁止 van-list 改 pageNumber
            searchParams: '',
            showPageBtn: false,
            jumpPageInput: '', // 自定义跳转页码（有值时上下钮变为「确定跳转」）
            
            // 滚动条的高度
            scrollTop: 0,
            scrollLock: false,
            
        }
    },

    computed: {
        totalPages() {
            const size = this.incomePayData.pageSize || 1
            const total = Number(this.total) || 0
            return total > 0 ? Math.ceil(total / size) : 0
        },
        isJumpMode() {
            return String(this.jumpPageInput || '').trim() !== ''
        },
    },

    mounted() {
        // this.onSlideChange()
        // 切换语言
        const { locale } = useI18n()  // 从国际化中取出配置项 locale 因为初始化时 用户没有指定语种 要使用系统默认的语种
        this.lang = localStorage.getItem("lang") ? localStorage.getItem("lang") : locale.value // 如果用户有选择特定语种 就使用用户指定的 不然就使用系统默认的
        locale.value = this.lang
        // 初始化页面的数据
        this.getData()
        this.loadCategories()

        return {}
    },
    // onBeforeUnmount() {
    //     console.log( '组件卸载之前执行的函数' )
    //     // window.removeEventListener('scroll', this.handleScroll)
    // },
    // destroyed 生命周期选项被重命名为 unmounted
    // beforeDestroy 生命周期选项被重命名为 beforeUnmount
    unmounted () { 
        // 离开页时清理
    },
    methods: {
        isLongTitle(title) {
            return String(title || '').length > 8
        },

        buildSearchParams() {
            let params = ``
            if (this.categoryId > 0) {
                params += `&category_id=${this.categoryId}`
            }
            this.searchParams = params
            return params
        },

        loadCategories() {
            const page = postPages(
                this.lang,
                localStorage.getItem('token'),
                '/api/video/category',
                100,
                1,
                ''
            )
            page.data.then((res) => {
                if (!res || 0 !== res.code) return
                // 接口返回 data 为数组
                this.categories = Array.isArray(res.data) ? res.data : (res.data.items || [])
            })
        },

        selectCategory(id) {
            const nextId = Number(id) || 0
            if (this.categoryId === nextId) {
                this.layerGame = false
                return
            }
            this.categoryId = nextId
            this.layerGame = false
            this.incomePayData.pageNumber = 1
            this.jumpPageInput = ''
            this.finished = true
            this.loading = false
            this.loadingMore = false
            this.pageSwitching = true
            this.list = []
            this.getData()
        },

        goPlay(item) {
            this.$router.push({
                path: `/computer/play/video/${item.video_id}/uuid`,
                query: {
                    id: item.video_id,
                    cover: item.cover,
                    time: item.created_at,
                    title: item.title,
                    amount: item.amount,
                },
            })
        },

        // 用户点击，触发切换语言请求。
        // 记录下用户选择的语言，路由跳转一下。
        switchLang(lang) {
            localStorage.setItem('lang', lang) // 存储
            return this.$router.go(0) // 刷新本页
        },
        toggleDrop() {
            // 如果 this.showDropDown 是真就取假，如果 this.showDropDown 是假就取真
            this.showDropDown = !this.showDropDown
        },
        openAccountList() {
            // layer.msg('打开左侧菜单')
            this.layerAccount = true
        },
        openGameList() {
            this.categoryLayerTitle = '视频分类'
            if (!this.categories.length) this.loadCategories()
            this.layerGame = true
        },
        getData()
        {
            this.buildSearchParams()
            // 发起请求时 要先隐藏分页按钮
            this.showPageBtn = false
            const requestPage = this.incomePayData.pageNumber
            // positionPage 方法是通过 JS 文件导入的
            const page = postPages(this.lang, localStorage.getItem('token'), '/api/video', this.incomePayData.pageSize, requestPage, this.searchParams)
            // 将异步获取的数据导入 VM 数据
            page.data.then(res =>{
                // 请求返回时若用户已翻到别的页，丢弃过期结果
                if (requestPage !== this.incomePayData.pageNumber) {
                    return
                }
                if (!res) {
                    this.loading = false
                    this.pageSwitching = false
                    return
                }
                if (0===res.code) {
                    this.list = res.data.items || []
                    this.total = res.data.total || 0
                    // 悬浮分页是「整页替换」模式：禁止 van-list 再上拉追加，否则 pageNumber 会被顶走
                    this.finished = true
                    this.loading = false
                    this.pageSwitching = false
                } else {
                    this.loading = false
                    this.pageSwitching = false
                    layer.msg(res.msg)
                }
            })
        }, // End getData()
        
        // 下拉刷新（仅 van-pull-refresh 触发，不要在滚动监听里重复刷新）
        onRefresh() {
            // this.incomePayData.pageNumber = 1
            // this.jumpPageInput = ''
            // this.finished = true
            // this.loading = false
            // this.loadingMore = false
            // this.pageSwitching = true
            // setTimeout(() => {
            //     this.isLoading = false
            //     this.getData()
            // }, 300)
        },
        // 上拉加载更多：在现有列表后追加，不能覆盖上一页
        onLoad() {
            // // 与悬浮分页冲突时关闭追加；空列表/翻页中一律不触发
            // if (this.pageSwitching || !this.list.length || this.finished || this.loadingMore) {
            //     this.loading = false
            //     return
            // }
            // // 首页已由 getData 拉取；首次 list 为空时若误触发，不要 ++ 成第 2 页丢第 1 页
            // if (this.incomePayData.pageNumber === 1 && this.list.length <= this.incomePayData.pageSize) {
            //     // 已有悬浮分页，不再用上拉推进页码
            //     this.finished = true
            //     this.loading = false
            //     return
            // }

            // this.loadingMore = true
            // const nextPage = this.incomePayData.pageNumber + 1
            // this.buildSearchParams()
            // const page = postPages(
            //     this.lang,
            //     localStorage.getItem('token'),
            //     '/api/video',
            //     this.incomePayData.pageSize,
            //     nextPage,
            //     this.searchParams
            // )
            // page.data.then(res => {
            //     if (!res) {
            //         this.loading = false
            //         return
            //     }
            //     if (0 === res.code) {
            //         const items = res.data.items || []
            //         this.total = res.data.total || 0
            //         this.list = this.list.concat(items)
            //         this.incomePayData.pageNumber = nextPage
            //         // 先标记 finished，再放开 loading，避免最后一页被重复拉取
            //         this.finished =
            //             this.list.length >= this.total ||
            //             items.length === 0 ||
            //             items.length < this.incomePayData.pageSize
            //         this.loading = false
            //     } else {
            //         this.loading = false
            //         layer.msg(res.msg)
            //     }
            // }).finally(() => {
            //     this.loadingMore = false
            // })
        }, // End onLoad(...) 上拉加载

        // 得到这个用户的基本信息
        // 主要是为了帐号退出后 更新当前用户的余额本地缓存
        getInfo()
        {
            
        },

        onPagerTopClick() {
            if (this.isJumpMode) {
                this.confirmJumpPage()
                return
            }
            this.goToPage(this.incomePayData.pageNumber - 1)
        },

        onPagerBottomClick() {
            if (this.isJumpMode) {
                this.confirmJumpPage()
                return
            }
            this.goToPage(this.incomePayData.pageNumber + 1)
        },

        confirmJumpPage() {
            const raw = String(this.jumpPageInput || '').trim()
            if (!raw) return
            const page = parseInt(raw, 10)
            if (!Number.isFinite(page) || page < 1) {
                layer.msg('请输入有效页码')
                return
            }
            if (this.totalPages > 0 && page > this.totalPages) {
                layer.msg(`最多 ${this.totalPages} 页`)
                return
            }
            this.goToPage(page)
            this.jumpPageInput = ''
        },

        goToPage(page) {
            const maxPage = this.totalPages || 1
            const target = Math.max(1, Math.min(Number(page) || 1, maxPage))
            if (target === this.incomePayData.pageNumber && this.list.length && !this.pageSwitching) {
                this.jumpPageInput = ''
                return
            }
            this.pageSwitching = true
            this.incomePayData.pageNumber = target
            // 翻页期间保持 finished，阻止 van-list 在 list 清空时把 pageNumber +1
            this.finished = true
            this.loading = false
            this.loadingMore = false
            this.list = []
            this.getData()
            this.scrollListToTop()
        },

        scrollListToTop() {
            this.$nextTick(() => {
                const el = this.$el && this.$el.querySelector
                    ? this.$el.querySelector('.demo-refresher')
                    : null
                if (el) el.scrollTop = 0
            })
        },
        
    } // End methods()
}
</script>

<!-- <style scoped src="../../public/css/main.min.css"></style> -->
<style lang="scss" scoped>
    .top-box-bg {
        // background-image: url('/public/upload/600x55.png');
        background-repeat: no-repeat; /** 图片不要平铺 */
        background-size: 100% 55px; /** 因为用大一倍的图，才够清晰，但是如果不定义自适应，只能显示一半的图片。所以宽度给 100% 但高度要给它限制 */
    }


    .van-pull-refresh { 
        height: calc(100vh - 50px) !important; 
        overflow: auto !important; 
    } 
    .van-list { 
        min-height: calc(100vh) !important; 
        overflow: hidden;
    }

    .video-grid {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 12px 10px;
        padding: 20px 30px 20px;
    }

    .video-card {
        min-width: 0;
        cursor: pointer;
    }

    .video-cover {
        width: 100%;
        aspect-ratio: 16 / 9;
        border-radius: 0;
        overflow: hidden;
        background: rgba(0, 0, 0, 0.25);

        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            display: block;
        }
    }

    .video-title-slot {
        margin-top: 0px;
        width: 100%;
        height: 28px;
        overflow: hidden;
        display: flex;
        align-items: center;
    }

    .video-title-track {
        display: flex;
        align-items: center;
        flex-wrap: nowrap;
        width: 100%;
        height: 28px;
        min-width: 0;
    }

    .video-title-track.is-scrolling {
        width: max-content;
        animation: video-title-marquee 10s linear infinite;
    }

    .video-title-text {
        color: #ffffff;
        text-shadow: 1px 1px #000000;
        font-weight: 400;
        font-size: 14px;
        line-height: 28px;
        height: 28px;
        padding: 0;
        margin: 0;
        white-space: nowrap;
        display: block;
        flex-shrink: 0;
        overflow: visible;
    }

    .video-title-track:not(.is-scrolling) .video-title-text {
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .video-title-track.is-scrolling .video-title-text + .video-title-text {
        margin-left: 2em;
    }

    @keyframes video-title-marquee {
        0% {
            transform: translate3d(0, 0, 0);
        }
        100% {
            transform: translate3d(-50%, 0, 0);
        }
    }

    .category-panel {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
        padding: 16px;
    }

    .category-tag {
        border: 1px solid rgba(255, 255, 255, 0.35);
        background: rgba(255, 255, 255, 0.08);
        color: #fff;
        border-radius: 999px;
        padding: 8px 14px;
        font-size: 14px;
        line-height: 1;
        cursor: pointer;
    }

    .category-tag.active {
        background: #009688;
        border-color: #009688;
    }

    .float-pager {
        position: fixed;
        right: 12px;
        bottom: 72px; /* 避开底部导航 55px */
        z-index: 60;
        display: flex;
        flex-direction: column;
        align-items: stretch;
        gap: 6px;
        width: 72px;
        padding: 8px 6px;
        border-radius: 10px;
        background: rgba(0, 0, 0, 0.55);
        backdrop-filter: blur(6px);
        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.35);
    }

    .float-pager-btn {
        border: 1px solid rgba(255, 255, 255, 0.35);
        background: rgba(255, 255, 255, 0.1);
        color: #fff;
        border-radius: 6px;
        padding: 8px 4px;
        font-size: 12px;
        line-height: 1.2;
        cursor: pointer;
        text-align: center;
        white-space: nowrap;

        &:active:not(.disabled) {
            background: #009688;
            border-color: #009688;
        }

        &.disabled {
            opacity: 0.35;
            cursor: not-allowed;
        }
    }

    .float-pager-input {
        width: 100%;
        box-sizing: border-box;
        border: 1px solid rgba(255, 255, 255, 0.35);
        background: rgba(255, 255, 255, 0.12);
        color: #fff;
        border-radius: 6px;
        padding: 8px 4px;
        font-size: 13px;
        line-height: 1.2;
        text-align: center;
        outline: none;
        -moz-appearance: textfield;

        &::placeholder {
            color: rgba(255, 255, 255, 0.55);
        }

        &:focus {
            border-color: #009688;
            background: rgba(0, 150, 136, 0.25);
        }

        &::-webkit-outer-spin-button,
        &::-webkit-inner-spin-button {
            -webkit-appearance: none;
            margin: 0;
        }
    }
</style>
